import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const CHFSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M8.91059 4.30085C8.44114 4.30085 8.06059 4.68141 8.06059 5.15085V7.93909H12.9202C13.2792 7.93909 13.5702 8.23011 13.5702 8.58909C13.5702 8.94808 13.2792 9.23909 12.9202 9.23909H8.06059V12.1717H9.31028C9.66927 12.1717 9.96028 12.4627 9.96028 12.8217C9.96028 13.1807 9.66927 13.4717 9.31028 13.4717H8.06059V16.3491C8.06059 16.7081 7.76957 16.9991 7.41059 16.9991C7.0516 16.9991 6.76059 16.7081 6.76059 16.3491V13.4717H4.84157C4.48259 13.4717 4.19157 13.1807 4.19157 12.8217C4.19157 12.4627 4.48259 12.1717 4.84157 12.1717H6.76059V5.15085C6.76059 3.96344 7.72317 3.00085 8.91059 3.00085H15.1584C15.5174 3.00085 15.8084 3.29187 15.8084 3.65085C15.8084 4.00984 15.5174 4.30085 15.1584 4.30085H8.91059Z"
        fill="#888888"
      />
    </svg>
  );
};
